<template>
  <div class="app-check-sim-card">
    <slot name="header">
      <h1>MEINE MOBIL SIM-KARTE</h1>
      <p>Hier können Sie den Status Ihrer SIM-Karte prüfen und Ihre PUK einsehen.</p>
    </slot>
    <b-row class="msisdn">
      <b-col class="label">
        <slot name="lblMsisdn"> Rufnummer</slot>
      </b-col>
      <b-col class="value">{{ msisdn }}</b-col>
    </b-row>
    <b-row class="status">
      <b-col class="label">
        <slot name="lblStatus"> SIM-Kartenstatus:</slot>
      </b-col>
      <b-col class="value">{{ status }}</b-col>
    </b-row>
    <b-row class="icc-id">
      <b-col class="label">
        <slot name="lblIccId'">SIM-Kartenseriennummer:</slot>
      </b-col>
      <b-col class="value">{{ iccId }}</b-col>
    </b-row>
    <b-row class="puk">
      <b-col class="label">
        <slot name="lblPUK">PUK (Super PIN):</slot>
      </b-col>
      <b-col class="value">{{ pukView }}</b-col>
    </b-row>
    <b-row class="puk-button">
      <b-col class="button">
        <b-button @click="togglePuk()" class="btn-view" type="button" variant="primary">
          <dyn-slot :slot-data="slotData">
            <slot name="btnView">PUK anzeigen</slot>
          </dyn-slot>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BButton, BCol, BRow } from 'bootstrap-vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import preFilledInput from '@/mixins/preFilledInput'
import DynSlot from '@/components/generic/DynSlot.vue'
import transaction from '@/mixins/transaction'

export default {
  name: 'ViewCheckSimCard',
  components: { 'b-row': BRow, 'b-col': BCol, 'b-button': BButton, DynSlot },
  mixins: [
    transaction('checkSIMCard'),
    preFilledInput('pukView', 'mask')
  ],
  data: function () {
    return {
      currentCustomer: null
    }
  },
  props: {
    mask: {
      type: String
    }
  },
  computed: {
    msisdn: function () {
      return this.currentCustomer?.contract?.msisdn
    },
    status: function () {
      return (this.currentCustomer?.contract?.simCard?.status === 'ACTIVE' ? 'aktiv' : 'inaktiv')
    },
    iccId: function () {
      return this.currentCustomer?.contract?.simCard?.iccId
    },
    maskShown: function () {
      return this.pukView === this.mask
    },
    slotData: function () {
      return {
        maskShown: this.maskShown
      }
    }
  },
  apollo: {
    allIdentMethods: function () {
      return wrapQuery(gql`query checkSIMCard {
        currentCustomer {
          contract {
            msisdn,
            simCard {
              iccId
              status
              puk
              type
            }
          }
        }
      }`, this, 'currentCustomer')
    }
  },
  methods: {
    togglePuk: function () {
      if (this.pukView === this.mask) {
        this.pukView = this.currentCustomer?.contract?.simCard?.puk
      } else this.pukView = this.mask
    }
  }
}
</script>
